import * as React from 'react';
import { connect } from 'react-redux';
import isNil from 'lodash/isNil';

import navigate from 'libs/router/navigate';

import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGIcon from 'components/svg-icon/SVGIcon';

import { needsActivationSelector } from 'selectors/account';
import {
  handleLoginResponse
} from 'components/external-integration/facebook/button/redux/actions';

import { __t, applyTranslations } from 'utils/language';
import { isLessThanDesktop } from 'utils/mobile-app';
import { getItem, removeItem } from 'utils/storage/sessionStorage';
import {
  CREATE_PROFILE_TEMP_AUTH_STORAGE_KEY
} from 'components/external-integration/facebook/button/utils/facebook-button';

applyTranslations(require('./i18n/profile-creation-step-finished.i18n.json'));

import type { InfluencerProfileForm } from 'types';
import type {
  FacebookButtonAuthResponse
} from 'components/external-integration/facebook/button/types';

type OwnProps = {
  details: InfluencerProfileForm,
  onSubmit: (details: InfluencerProfileForm) => void
};

type StateProps = {
  needsActivation: boolean
};

type DispatchProps = {
  dispatchHandleLoginResponse: (
    authResponse: FacebookButtonAuthResponse,
    profileId: number | undefined | null
  ) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

class ProfileCreationStepFinished extends React.PureComponent<Props> {
  handleProfileBoost = (): void => {
    const { details, onSubmit } = this.props;

    onSubmit(details);
  };

  handleFinish = (): void => {
    navigate.to('/');
  };

  handleFBLogin = async (
    tempAuthResponse: FacebookButtonAuthResponse
  ): Promise<void> => {
    const { details, dispatchHandleLoginResponse } = this.props;
    const profileId = details.id;

    await dispatchHandleLoginResponse(tempAuthResponse, profileId);

    removeItem(CREATE_PROFILE_TEMP_AUTH_STORAGE_KEY);
  };

  render() {
    const { needsActivation } = this.props;
    const size = isLessThanDesktop() ? 98 : 196;
    const tempAuthResponse = getItem(CREATE_PROFILE_TEMP_AUTH_STORAGE_KEY);

    if (!isNil(tempAuthResponse)) {
      this.handleFBLogin(JSON.parse(tempAuthResponse));
    }

    return (
      <div className="profile-creation-step-finished">
        <div className="profile-creation-step-finished__heading">
          {__t('profile_creation_step_finished.heading')}
        </div>
        <SVGIcon
          name="profile-creation-step-finished"
          width={size}
          height={size}
        />
        <div className="profile-creation-step-finished__description">
          {__t('profile_creation_step_finished.description')}
          {
            needsActivation &&
              <div className="profile-creation-step-finished__comment">
                {__t('profile_creation_step_finished.comment')}
              </div>
          }
        </div>
        <div className="profile-creation-step-finished__buttons">
          <ActionButton
            color="primary"
            width="maximum"
            onClick={this.handleProfileBoost}
          >
            {__t('profile_creation_step_finished.button_profile_boost')}
          </ActionButton>
          <ActionButton
            color="secondary"
            width="maximum"
            onClick={this.handleFinish}
          >
            {__t('profile_creation_step_finished.button_explore')}
          </ActionButton>
        </div>
      </div>
    );
  }
}

const mapPropsToState = (state): StateProps => ({
  needsActivation: needsActivationSelector(state)
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchHandleLoginResponse: (
    authResponse: FacebookButtonAuthResponse,
    profileId: number | undefined | null
  ) => (
    dispatch(handleLoginResponse(authResponse, profileId ?? -1))
  )
});

export default connect(mapPropsToState, mapDispatchToProps)(ProfileCreationStepFinished);
